import { Dispatch, SetStateAction, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, Input, CardMedia } from "@mui/material";
import { showError, showToast } from "../constants/toasts";
import {
  useAddCategoryMutation,
  useAddInternalProcessMutation,
  useUpdateCategoryMutation,
  useUpdateInternalProcessMutation,
} from "../service/category";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedId?: string;
  selectedCategory?: any;
  getProcessApi: () => void;
}

export default function AddInternalProcess({
  open,
  onClose,
  setOpen,
  selectedId,
  selectedCategory,
  getProcessApi,
}: AddCategoryModalProps) {
  const [addCategory] = useAddCategoryMutation();
  const [updateCategory] = useUpdateCategoryMutation();
  const [addProcess] = useAddInternalProcessMutation();
  const [updateProcess] = useUpdateInternalProcessMutation();

  const [error, setError] = useState(false);
  const [image, setImage] = useState<any>();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");

  const handleAddCategory = async () => {
    setError(true);
    if (name.trim() === "") {
      showError("Name is required");
      return;
    }

    setLoading(true);
    try {
      let body = {
        name: name,
        ...(selectedId ? { id: selectedId } : {}),
      };

      let response;
      if (selectedId) {
        response = await updateProcess(body).unwrap();
      } else {
        response = await addProcess(body).unwrap();
      }
      if (response?.status === 200) {
        setError(false);
        setOpen(false);
        showToast(
          selectedId
            ? "Internal Process updated successfully"
            : "Internal Process added successfully"
        );
        getProcessApi();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && selectedCategory) {
      setName(selectedCategory?.name || "");
    } else if (open && !selectedCategory) {
      setName("");
    }
  }, [open, selectedCategory]);

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>{selectedId ? "Edit Category" : "Add Category"}</h2>
            <div
              className="btn-close"
              tabIndex={0}
              role="button"
              onClick={() => {
                setError(false);
                setOpen(false);
                setName("");
                setImage("");
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <label htmlFor="category-name">Category Name</label>
              <TextField
                id="category-name"
                placeholder="Enter Category Name"
                fullWidth
                hiddenLabel
                value={name}
                inputProps={{ maxLength: 40 }}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setName(e.target.value);
                  }
                }}
              />
              {error && name == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={handleAddCategory}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
